import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './SymptomChecker.css' ;

const ExerciseList = () => {
  const [bodyParts, setBodyParts] = useState([]);
  const [exercises, setExercises] = useState([]);
  const [selectedBodyPart, setSelectedBodyPart] = useState('');

  useEffect(() => {
    const options = {
      method: 'GET',
      url: 'https://exercisedb.p.rapidapi.com/exercises/bodyPartList',
      headers: {
        'X-RapidAPI-Key': '479d517940mshd97322f816c2b8fp13f49ajsn309a4ff38d1a',
        'X-RapidAPI-Host': 'exercisedb.p.rapidapi.com'
      }
    };

    const fetchBodyParts = async () => {
      try {
        const response = await axios.request(options);
        setBodyParts(response.data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchBodyParts();
  }, []);

  useEffect(() => {
    if (selectedBodyPart) {
      const options = {
        method: 'GET',
        url: `https://exercisedb.p.rapidapi.com/exercises/bodyPart/${selectedBodyPart}`,
        headers: {
          'X-RapidAPI-Key': '479d517940mshd97322f816c2b8fp13f49ajsn309a4ff38d1a',
        'X-RapidAPI-Host': 'exercisedb.p.rapidapi.com'
        }
      };

      const fetchExercises = async () => {
        try {
          const response = await axios.request(options);
          console.log(response.data);
          setExercises(response.data);
        } catch (error) {
          console.error(error);
        }
      };

      fetchExercises();
    }
  }, [selectedBodyPart]);

  const capitalizeWords = (str) => {
    return str
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  return (
    <>
        <div className='container'>
            <h1 className = "logoText">Stay Fit!</h1>
            <select 
                onChange={e => setSelectedBodyPart(e.target.value)}
                className='picker'
            >
                <option value="">Select a body part</option>
                {
                    bodyParts.map(bodyPart => (
                        <option key={bodyPart} value={bodyPart}>{capitalizeWords(bodyPart)}</option>
                    ))
                }
            </select>
            <ul className='list'>
                {exercises.slice(0,30).map((item) => (
                    <div key={item.id} className = "listItem">
                    <img src={item.gifUrl} className='listImage'/>
                    <p  className='listTitle'>{capitalizeWords(item.name)}</p>
                    </div>
                ))}
            </ul>
        </div>
    </>
  );
};

export default ExerciseList;
